<template>
  <navbar
    class="navbar-menu"
    position="fixed"
    type="white"
    menu-classes="ml-auto"
    ref="navbar-principal"
  >
    <template>
      <router-link v-popover:popover1 class="navbar-brand" to="/Dashboards">
        <img v-lazy="'/img/logo.png'" height="20px" />
      </router-link>

      <a class="navbar-brand">
        <i class="now-ui-icons users_single-02 color-menu" aria-hidden="true"></i>
        <span class="color-menu">{{ email }}</span>
      </a>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <router-link class="nav-link color-menu" :to="{ path: '/Operations' }"
          >Operations</router-link
        >
      </li>
      <li class="nav-item">
        <router-link class="nav-link color-menu" :to="{ path: '/Expats' }"
          >Expats
        </router-link>
      </li>
      <!-- <li class="nav-item">
        <router-link class="nav-link color-menu" :to="{ path: '/Shippers' }"
          >Shippers
        </router-link>
      </li> -->
      <li class="nav-item">
        <router-link class="nav-link color-menu" :to="{ path: '/Companies' }"
          >Companies
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link color-menu" :to="{ path: '/Dashboards' }"
          >Dashboards
        </router-link>
      </li>
      <li class="nav-item" v-if="this.profile == 'admin'">
        <router-link class="nav-link color-menu" :to="{ path: '/Users' }"
          >Users
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link color-menu" :to="{ path: '/Profile' }"
          >Profile
        </router-link>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title=" Logout"
          data-placement="bottom"
          @click="signOut"
          target="_blank"
        >
          <i class="fas fa-power-off color-menu"></i>
          <p class="d-lg-none d-xl-none color-menu"> Logout</p>
        </a>
      </li>
    </template>
  </navbar>
</template>


<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";
import { Popover } from "element-ui";
import { Auth } from "aws-amplify";
export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
  },
  data() {
    return {
      profile: "",
      email: "",
      /////////////////////
      permisos: [],
      token: "",
      nombre: "",
    };
  },
  async created() {
    if (localStorage.getItem("idToken")) {
      try {
        const { attributes } = await Auth.currentAuthenticatedUser();
        let email = attributes["email"];
        this.getUser(email);
      } catch (error) {
        this.$router.replace("/Login").catch((err) => {});
      }
    } else {
      this.$router.replace("/Login").catch((err) => {});
    }
  },
  methods: {
    getUser(email) {
      let token = localStorage.getItem("idToken");
      this.axios
        .get(
          `${process.env.VUE_APP_USERS}`,
          {
            params: {
              depth: true,
              user_email: email,
            },
          },
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.email = email;
          this.profile = res.data[0]["profile_details"]["profile_name"];
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    async signOut() {
      try {
        await Auth.signOut({ global: true });
        this.$refs["navbar-principal"].close();
        sessionStorage.clear();
        localStorage.clear();
        this.$router.replace("/Login").catch((err) => {});
      } catch (error) {
        // console.log("error signing out: ", error);
      }
    },
    abrirDropdown(x, id) {
      let y = x;
      if (id == 1) {
        this.$refs[y + ""].toggleDropDown();
      }
      if (id == 2) {
        this.$refs[y + ""].toggleDropDown();
      }
      if (id == 3) {
        this.$refs[y + ""].toggleDropDown();
      }
      // this.buscarPermisos();
    },
    cerrarDropdown(x, id) {
      let y = x;
      if (id == 1) {
        this.$refs[y + ""].closeDropDown();
      }
      if (id == 2) {
        this.$refs[y + ""].closeDropDown();
      }
      if (id == 3) {
        this.$refs[y + ""].closeDropDown();
      }
    },
  },
};
</script>

<style scoped>
.bg-white{
  background-color: #2196f3 !important;
}
.color-menu{
  color: white !important;
}
</style>